import { motion } from "framer-motion";
import { Quote, Star } from "lucide-react";

const testimonios = [
    {
        n: "Alicia P.",
        loc: "Parla",
        q: "Resultados reales y entrenadores increíbles. Aquí sí te ayudan de verdad.",
    },
    {
        n: "Javier L.",
        loc: "Getafe",
        q: "Profesionalidad absoluta. He notado el cambio en 8 semanas.",
    },
    {
        n: "Cristina F.",
        loc: "Fuenlabrada",
        q: "El ambiente es brutal. Vas con ganas y sales con más.",
    },
    {
        n: "Daniel R.",
        loc: "Parla",
        q: "Buen ambiente, instalaciones limpias y un personal súper amable.",
    },
    {
        n: "Lucía V.",
        loc: "Getafe",
        q: "Excelente trato. Entrenadores muy profesionales y cercanos.",
    },
    {
        n: "Sergio M.",
        loc: "Fuenlabrada",
        q: "Mejor lugar para entrenar de la zona sur. Monitores muy majos.",
    },
];

export default function Testimonios() {
    return (
        <section
            data-testid="testimonios-section"
            className="relative bg-[#0A0A0A] py-24 md:py-32 overflow-hidden"
        >
            <div className="max-w-7xl mx-auto px-5 md:px-10">
                <div className="text-center mb-14">
                    <span className="font-display tracking-[0.4em] text-xs text-brand-orange">
                        // LO QUE DICEN
                    </span>
                    <h2 className="font-display text-5xl md:text-7xl lg:text-8xl mt-4 leading-[0.9] text-brand-text">
                        LA VOZ DE LOS
                        <br />
                        <span className="gold-text">QUE ENTRENAN.</span>
                    </h2>
                </div>

                <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5">
                    {testimonios.map((t, idx) => (
                        <motion.div
                            key={t.n}
                            initial={{ opacity: 0, y: 30 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, amount: 0.2 }}
                            transition={{ delay: idx * 0.08 }}
                            data-testid={`testimonio-card-${idx}`}
                            className="relative bg-[#0F0F0F] border border-white/10 p-7 md:p-8 hover:border-brand-orange/60 transition-all duration-500 glow-border"
                        >
                            <Quote
                                className="absolute top-5 right-5 text-brand-orange/30"
                                size={42}
                            />
                            <div className="flex gap-1 mb-4">
                                {[0, 1, 2, 3, 4].map((s) => (
                                    <Star
                                        key={s}
                                        size={14}
                                        className="text-brand-gold fill-brand-gold"
                                    />
                                ))}
                            </div>
                            <p className="text-brand-text text-lg leading-relaxed">
                                "{t.q}"
                            </p>
                            <div className="mt-6 pt-5 border-t border-white/10 flex items-center justify-between">
                                <span className="font-display text-xl text-brand-text">
                                    {t.n}
                                </span>
                                <span className="font-display tracking-[0.3em] text-[10px] text-brand-orange">
                                    {t.loc.toUpperCase()}
                                </span>
                            </div>
                        </motion.div>
                    ))}
                </div>
            </div>
        </section>
    );
}
